import './lib/sentry';
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import { iniciarAtualizacaoDoPwa } from "./lib/pwa-update";
import "./i18n";
import "./index.css";

// Service worker fora do Capacitor nativo. O registro (com os callbacks NAS OPÇÕES do
// registerSW — atribuir depois não funciona) e a política de recarga vivem em
// lib/pwa-update.ts; o aviso "Nova versão disponível" é o hook usePwaUpdate.
const isCapacitorNative =
  typeof (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor !== "undefined" &&
  (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.();

if (!isCapacitorNative) {
  iniciarAtualizacaoDoPwa(registerSW);
}

createRoot(document.getElementById("root")!).render(<App />);
